module.exports = __webpack_public_path__ + "img/bezier-curve-03.f44342fd.svg";